import Vue from 'vue'
import config from '@/config'
import axios from 'axios'
import moment from 'moment'
import alertHelper from '@/helpers/alert'
import repairStatus from '@/helpers/repair_status';

function lastDays(repair) {
  const now = moment();
  const timestamp = moment.unix(repair.timestamp);
  const days = timestamp.diff(now, 'days')
  return days;
}

function showStreetAddress(repair) {
  const { unit, num, street } = repair.house
  // console.log({showStreetAddress: [unit?[unit, num].join('/'):num, street].join(' ')})
  return [unit?[unit, num].join('/'):num, street].join(' ');
}

function showRegion(repair) {
  const { suburb, city } = repair.house
  return [suburb, city].join(', ');
}

function showStatus(repair) {
  switch(repair.status) {
    case repairStatus.Discard: return 'Discard';
    case repairStatus.Proposed: return 'Proposed';
    case repairStatus.Assigned: return 'Assigned';
    case repairStatus.Performed: return 'Performed';
    case repairStatus.Finished: return 'Finished';
    case repairStatus.Archived: return 'Archived';
  }
}


const state = {
  repairs: [],
  selectedRepair: {},
  handymen: []
}

const getters = {
  get(state) {
    return state.repairs
  },
  getRepairById(state, id) {
    const repair =  state.repairs.filter(r => r.id === id)
    return repair.length > 0 ? repair[0] : {}
  },
  getSelected(state) {
    return state.selectedRepair
  },
  getHandymen(state) {
    return state.handymen;
  }
}

const mutations = {
  set(state, repairs) {
    repairs.sort((a, b) => a.timestamp - b.timestamp)
    const enhanced = repairs.map(repair => ({
      ...repair,
      lastDays: lastDays(repair),
      showStreetAddress: showStreetAddress(repair),
      showRegion: showRegion(repair),
      showStatus: showStatus(repair),
    }))
    Vue.set(state, 'repairs', enhanced)
  },
  add(state, repair) {
    state.repairs.push(repair)
  },
  update(state, repair) {
    // console.log('???commit is here', { repair })
    state.repairs.forEach((d) => {
      if (d.id === repair.id) {
        Object.assign(d, repair);
        Object.assign(d, {
          lastDays: lastDays(d),
          showStreetAddress: showStreetAddress(repair),
          showRegion: showRegion(repair),
          showStatus: showStatus(repair),
        })
        Vue.set(state, 'selectedRepair', d)
      }
    })
  },
  delete(state, id) {
    state.repairs.forEach((repair, index) => {
      if (repair.id === id) {
        state.repairs.splice(index, 1)
      }
    })
  },
  select(state, repair) {
    Vue.set(state, 'selectedRepair', repair)
  },
  selectFromId(state, repairId) {
    const repairs =  state.repairs.filter(r => r.id === repairId)
    const repair = repairs.length > 0 ? repairs[0] : {}
    // console.log('selectedRepair', repair)
    Vue.set(state, 'selectedRepair', repair)
  },
  deleteAttachment(state, { repairId, fileId }) {
    state.repairs.forEach((houseRepair) => {
      if (houseRepair.id === repairId) {
        houseRepair.files.forEach((file, index) => {
          if (file.id === fileId) {
            houseRepair.files.splice(index, 1)
          }
        })
      }
    })
  },
  setHandymen(state, handymen) {
    state.handymen = handymen;
  }
}

const actions = {
  async fetchAll({ commit }, house_id) {
    try {
      const response = await axios.get(config.apiBaseUrl + 'task/find', {
        params: {
          house_id,
          title: 'maintenance'
        },
      })

      if (response.data.errno === 0) {
        let repairs = response.data.data

        if (repairs.length > 0) {
          repairs.sort((a, b) => a.timestamp - b.timestamp)
        }
        commit('set', repairs)
      } else {
        alertHelper.error(response.data.errmsg)
      }
    } catch (error) {
      alertHelper.error(error.toString())
    }
  },
  async add({commit}, repair) {
    try {
      const response = await axios.post(config.apiBaseUrl + 'task/schedule/', repair)

      if (response.data.errno === 0) {
        commit('add', Object.assign(repair, response.data.data))
        // TODO: Return this data so the view knows about this new id
        // We will not need this once we have routes for repairs
        return repair.id
      } else {
        alertHelper.error(response.data.errmsg)
      }
    } catch (error) {
      alertHelper.error(error.toString())
    }
  },
  async assign({commit}, repair) {
    try {
      const response = await axios.post(config.apiBaseUrl + 'task/confirm/', repair)

      if (response.data.errno === 0) {
        const newrepair = response.data.data;
        console.log({ newrepair })
        commit('update', Object.assign(repair, newrepair))
        // TODO: Return this data so the view knows about this new id
        // We will not need this once we have routes for repairs
        return response.data.data.id
      } else {
        alertHelper.error(response.data.errmsg)
      }
    } catch (error) {
      alertHelper.error(error.toString())
    }
  },
  async comment({commit, dispatch}, {repair, note} ) {
    try {
      if (note) {
        repair.description = note;
      }
      const response = await axios.post(config.apiBaseUrl + 'task/note', repair)
      if (response.data.errno === 0) {
        dispatch('fetch', repair.id)
      } else {
        alertHelper.error(response.data.errmsg)
      }
    } catch (error) {
      alertHelper.error(error.toString())
    }
  },
  async finish({commit}, repair) {
    try {
      const response = await axios.post(config.apiBaseUrl + 'task/generateReport/',  { task_id: repair.id })
      console.log({ response: response.data})
      if (response.data.errno === 0) {
        await commit('update', response.data.data)
        console.log('update', repair)
      } else {
        alertHelper.error(response.data.errmsg)
      }
    } catch (error) {
      alertHelper.error(error.toString())
    }
  },
  async close({dispatch}, repair) {
    try {
      const response = await axios.get(`${config.apiBaseUrl}task/sendReport`, {params: { task_id: repair.id }})
      if (response.data.errno === 0) {
        dispatch('fetch', repair.id)
        // commit('update', response.data.data)
      } else {
        alertHelper.error(response.data.errmsg)
      }
    } catch (error) {
      alertHelper.error(error.toString())
    }
  },
  async update({commit, dispatch}, update) {
    try {
      const response = await axios.post(`${config.apiBaseUrl}task/update`, update)
      if (response.data.errno === 0) {
        dispatch('fetch', update.id)
      } else {
        alertHelper.error(response.data.errmsg)
      }
    } catch (error) {
      alertHelper.error(error.toString())
    }
  },
  async cancel({commit}, repair) {
    try {
      const verb = (repair.status >= repairStatus.Assigned)? 'schedule': 'cancel'
      const response = await axios.post(config.apiBaseUrl + `task/${verb}`, repair)
      if (response.data.errno === 0) {
        commit('update', Object.assign(repair, response.data.data))
      } else {
        alertHelper.error(response.data.errmsg)
      }
    } catch (error) {
      alertHelper.error(error.toString())
    }
  },
  async reopen({commit}, repair) {
    try {
      const response = await axios.post(config.apiBaseUrl + `task/schedule`, repair)
      if (response.data.errno === 0) {
        commit('update', Object.assign(repair, response.data.data))
      } else {
        alertHelper.error(response.data.errmsg)
      }
    } catch (error) {
      alertHelper.error(error.toString())
    }
  },
  /**
   * Deletes the repair attachment
   *
   * @param  {object}
   * @param  {number} id of the repair
   * @param  {number} id of the file
   */
  async deleteAttachment({commit}, { repairId, fileId }) {
    if (!confirm('Are you sure?')) {
      return false;
    }
    const url = config.apiBaseUrl + 'repair/deletefile'

    try {
      const response = await axios.post(url, {task_id: repairId, id: fileId})

      if (response.data.errno === 0) {
        commit('deleteAttachment', { repairId, fileId })
        alertHelper.success('Successfully deleted repair file')
        return true
      } else {
        alertHelper.error(response.data.errmsg)
      }
    } catch (error) {
      alertHelper.error(error.toString())
    }
    return false
  },
  async uploadInvoice({commit}, {repair, file} ) {
    console.log('vuex:Repairs.uploadInvoice', { repair, file })
    const formData = new FormData()
    formData.append('file', file, file.name)
    formData.append('task_id', repair.id)
    try {
      const response = await axios.post(
        config.apiBaseUrl + 'task/uploadReport',
        formData
      )
      if (response.data.errno === 0) {
        alertHelper.success('Document uploaded successfully.')
        repair.status = repairStatus.Performed
        commit('update', repair)
        return true
      } else {
        alertHelper.error(response.data.errmsg)
      }
    } catch (error) {
      alertHelper.error(error.toString())
    }
    return false
  },
  async fetch({commit}, repairId) {
    try {
      const response = await axios.get(config.apiBaseUrl + 'task/find', {
        params: {
          task_id: repairId
        }
      })
      if (response.data.errno === 0) {
        const repair = response.data.data[0]
        commit('update', repair)
        return repair;
      } else {
        alertHelper.error(response.data.errmsg)
      }
    } catch (error) {
      alertHelper.error(error.toString())
    }
  },
  async select({commit}, repair) {
    commit('select', repair)
  },
  async fetchHandymen({commit}) {
    try {
      const response = await axios.get(config.apiBaseUrl + 'account/team')
      if (response.data.errno === 0) {
        const handymen = response.data.data
        commit('setHandymen', handymen)
        return handymen;
      } else {
        alertHelper.error(response.data.errmsg)
      }
    } catch (error) {
      alertHelper.error(error.toString())
    }
  }
}

const storeModule = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
}

export default storeModule
